import { formatDate } from '../../../common/helpers'

const props = props => ({
  eventFactory: (fn, value) => event => {
    fn(event, value)
  },

  setCustomDateRange: (startDate, endDate) => {
    props.modalCloseDispatch()

    const range = {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate)
    }
    props.setFilter('date', range)
    props.setFilterDateLabel(`${range.startDate} - ${range.endDate}`)
  }
})

export default props
